import React from 'react'

const Menubtn = ({btnname}) => {
  return (
    <button className='bg-[#00D290] text-white px-6 py-2 rounded-full'>{btnname}</button>
  )
}

export default Menubtn